export default {
  "content": "<title>Mic</title><path d=\"M192 448h128m64-240v32c0 70.4-57.6 128-128 128s-128-57.6-128-128v-32m128 160v80\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 64a63.68 63.68 0 00-64 64v111c0 35.2 29 65 64 65s64-29 64-65V128c0-36-28-64-64-64z\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};